module.exports = __webpack_public_path__ + "static/media/MHRP29N0016.416da895.svg";